import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Radio,
  Row,
  Upload,
  Select,
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';

import {
  fetchAlloysList,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import {
  fetchCustomerList,
  resetCurrentCustomerPage,
  resetCustomerList,
} from '../../slices/customer';
import {
  fetchTempersList,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../slices/tempers';

import {
  fetchDieProfileById,
  fetchDieProfileList,
  resetCurrentDieProfilePage,
  resetDieProfileList,
} from './../../slices/die-profile';
import {
  fetchQuotationById,
  quotationCreateWorkoder,
} from '../../slices/quotation';
import { fetchPackingModeList, resetPackingModeData } from '../../slices/packing';
import { fetchjobWorkList, resetJobWorkList } from '../../slices/job-work';
import moment from 'moment';
import { fetchNalcoRateForQuotation } from '../../slices/nalco-rate';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';

const { Option } = Select;

function ConvertToWorkOrder() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [sameCustomer, setSameCustomer] = useState(false);
  const [currentWTKg, setCurrentWTKg] = useState('');

  const [form] = Form.useForm();
  const inputRef = useRef(null);
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const { id } = useParams();
  const [searchAlloy, setSearchAlloy] = useState('');
  const [selectedOption, setSelectedOption] = useState({});
  const [searchTemper, setSearchTemper] = useState('');

  const { list: customerList } = useSelector(state => state.customer);
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);
  const [searchCustomer, setSearchCustomer] = useState('');

  const [initialValues, setInitialValues] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedSurfaceFinish, setSelectedSurfaceFinish] = useState('');
  const [selectedEngineeringOptions, setSelectedEngineeringOptions] = useState({});
  const [selectedJobWork, setSelectedJobWork] = useState('');
  const [quotationNumber, setQuotationNumber] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [uploadDiaDiagramError, setUploadDiaDiagramError] = useState('');

  const validateFileList = () => {
    if (fileList.length === 0) {
      return Promise.reject(new Error('Please upload a file.'));
    }
    return Promise.resolve();
  };

  const handleFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    const uploadedFile = newFileList[0]?.originFileObj;

    if (uploadedFile) {
      if (uploadedFile.size / 1024 / 1024 > 2) {
        setUploadDiaDiagramError('File size must be smaller than 2MB!');
        setFileList([]);
      } else {
        setUploadDiaDiagramError('');
        setFileList(newFileList);
        form.validateFields(['po_copy']);
      }
    } else {
      setUploadDiaDiagramError('');
      setFileList([]);
    }
  };

  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        const response = await dispatch(fetchQuotationById(id)).unwrap();
        if (response) {
          form.setFieldsValue({
            bill_to: response.customer?.id || null,
            tolerance: '+-10%',
            project_name: response.project_name,
            remarks: response.remarks,
            workorder_type: 'In House',
            packing_type: response.packing_type,
            work_order_details:
              response?.quotation_details?.length > 0
                ? response.quotation_details.map(detail => ({
                  id: detail ? detail.id : null,
                  die_profile: detail.die_profile ? { label: detail.die_profile.die_number, value: detail.die_profile.id } : undefined,
                  customer_reference_number: detail?.customer_reference_no || '',
                  conversion: detail?.conversion || '',
                  alloy: detail?.alloy ? {
                    label: `${detail.alloy.alloy_code}${detail.alloy.standard_name ? ' - ' + detail.alloy.standard_name : ''}`,
                    value: detail.alloy.id
                  } : null,
                  temper: detail.temper
                    ? { label: detail.temper.name, value: detail.temper.id }
                    : undefined,
                  length: detail?.length || null,
                  finishing_price: detail?.finishing_price || null,
                  nalco_rate: detail?.price_per_kg || '',
                  nalco_rate_change_reason:
                    detail?.nalco_rate_change_reason || null,
                  modify_nalco_rate: detail?.modify_nalco_rate,
                  unit_of_measurement: detail?.unit_of_measurement || '',
                  description: detail?.description || '',
                  surface_treatment: detail?.surface_treatment || '',
                  surface_finish: detail?.surface_finish || '',
                  net_weight: detail?.net_weight || null,
                  min_weight: detail?.min_weight || null,
                  max_weight: detail?.max_weight || null,
                  pieces: detail?.pieces || null,
                  wt_kg_p_mt: detail?.die_profile?.wt_kg_p_mt || null, // Convert to number
                  jobworks: detail?.jobworks || [],
                  cutting: detail?.cutting || false,
                  machinings: detail.machinings || false,
                  deburring: detail.deburring || false,
                  cutting_price: detail.cutting_price || undefined,
                  machinings_price: detail.machinings_price || undefined,
                  deburring_price: detail.deburring_price || undefined,
                  anodising: detail.anodising || false,
                  powder_coating: detail.powder_coating || false,
                  pvdf: detail.pvdf || false,
                  anodising_description: detail.anodising_description || undefined,
                  anodising_price: detail.anodising_price || undefined,
                  powder_coating_description: detail.powder_coating_description || undefined,
                  powder_coating_price: detail.powder_coating_price || undefined,
                  pvdf_description: detail.pvdf_description || undefined,
                  pvdf_price: detail.pvdf_price || undefined,
                  laser_marking_description: detail.laser_marking_description || undefined,
                  laser_marking_price: detail.laser_marking_price || undefined,
                }))
                : [
                  {
                    die_profile: undefined,
                    customer_reference_no: '',
                    alloy: null,
                    temper: undefined,
                    length: null,
                    conversion: '',
                    finishing_price: null,
                    price_per_kg: '',
                    unit_of_measurement: '',
                    description: '',
                    surface_treatment: '',
                    surface_finish: '',
                    net_weight: null,
                    pieces: null,
                    jobworks: [],
                    cutting: false,
                    machinings: false,
                    deburring: false,
                    cutting_price: undefined,
                    machinings_price: undefined,
                    deburring_price: undefined,
                    anodising: false,
                    powder_coating: false,
                    pvdf: false,
                    anodising_description: undefined,
                    anodising_price: undefined,
                    powder_coating_description: undefined,
                    powder_coating_price: undefined,
                    pvdf_description: undefined,
                    pvdf_price: undefined,
                    laser_marking_description: undefined,
                    laser_marking_price: undefined,
                  },
                ],
          });
          handleToleranceChange('+-10%');
          setQuotationNumber(response?.quotation_no);
         
        }
      } catch (error) {
        console.error('Error fetching quotation:', error);
      }
    };

    fetchQuotation();
  }, [id, form, dispatch, fetchQuotationById]);


  useEffect(() => {
    const orderDate = dayjs();
    const deliveryDate = orderDate.clone().add(12, 'days');
    form.setFieldsValue({
      order_date: orderDate,
      delivery_date: deliveryDate,
    });
  }, [form]);

  const disablePastDates = current => {
    const currentOrderDate = form.getFieldValue('order_date') || moment();
    return (
      current &&
      current <
      moment.max(moment().startOf('day').add(1, 'days'), currentOrderDate)
    );
  };

  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);

  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);

  const {
    list: temperList,
    loading: temperLoading,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);

  useEffect(() => {
    dispatch(
      fetchCustomerList({
        page: 1, pagesize: 1000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
      dispatch(
        fetchAlloysList({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
      dispatch(
        fetchTempersList({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
    );
    dispatch(
      fetchDieProfileList({
        page: 1,
        pagesize: 5000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(fetchjobWorkList());
    dispatch(resetDieProfileList());
    dispatch(resetCurrentCustomerPage());
    dispatch(resetCurrentAlloyListPage());
    dispatch(resetTempersList());
    dispatch(resetCurrentTemperPage());
    dispatch(resetCustomerList());
    dispatch(resetAlloyList());
  }, [dispatch, page, pagesize, search, orderBy]);

  useEffect(() => {
    fetchCustomerList();
    fetchjobWorkList();
    fetchAlloysList();
    fetchTempersList();
    fetchDieProfileList();
    resetCurrentDieProfilePage();
    resetDieProfileList();
    resetCustomerList();
    resetCurrentCustomerPage();
    resetAlloyList();
    resetCurrentAlloyListPage();
    resetTempersList();
    resetCurrentTemperPage();
  }, []);

  const onScrollDieProfile = async event => {
    const target = event.target;
    if (!dieProfileLoading && dieProfileHasMore && target.scrollTop + target.offsetHeight === target.scrollHeight) {
      dispatch(
        fetchDieProfileList({ page: dieProfileCurrentPage, pagesize: 5000 }),
      );
    }
  };

  const handleSearchDieProfile = e => {
    const value = e.target.value;
    if (value) {
      setSearchDieProfile(value);
      dispatch(fetchDieProfileList({ page: 1, pagesize: 5000, search: value }));
    } else {
      setSearchDieProfile('');
      dispatch(fetchDieProfileList({ page: 1, pagesize: 5000 }));
    }
  };

  const handleAlloy = (selected, option, index) => {
    const updatedDetails = form
      .getFieldValue('work_order_details')
      .map((item, i) => (i === index ? { ...item, alloy: selected } : item));

    form.setFieldsValue({ work_order_details: updatedDetails });
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);

    if (value) {
      setSearchAlloy(value);
      dispatch(resetAlloyList());
      dispatch(fetchAlloysList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloysList({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloysList({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };

  const [isEditable, setIsEditable] = useState(false);
  const [isRemarkRequired, setIsRemarkRequired] = useState(false);
  const [pricePerKg, setPricePerKg] = useState('');
  const handleCheckboxChange = e => {
    setIsEditable(e.target.checked);
  };
  const handleNalcoChange = value => {
    setIsRemarkRequired(value && parseFloat(value) > 0);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(
          fetchNalcoRateForQuotation(),
        );
        if (response) {
          setPricePerKg(response.payload.data.rate);
        } else {
          console.error('Unexpected response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [dispatch]);

  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      setSearchTemper(value);
      dispatch(resetTempersList());
      dispatch(fetchTempersList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTempersList({ page: 1, pagesize: 1000 }));
    }
  };

  const handleBillToChange = value => {
    form.setFieldValue('bill_to', value); // Update field value
    form.validateFields(['bill_to']); // Trigger validation
    handleChangeCustomer(value);
    if (value === form.getFieldValue('ship_to')) {
      setSameCustomer(true);
    } else {
      setSameCustomer(false);
    }
  };
  const handleShipToChange = value => {
    form.setFieldValue('ship_to', value); // Update field value
    form.validateFields(['ship_to']); // Trigger validation
    handleChangeCustomer(value);
    if (value === form.getFieldValue('bill_to')) {
      setSameCustomer(true);
    } else {
      setSameCustomer(false);
    }
  };
  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTempersList({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };


  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      setSearchCustomer(value);
      dispatch(fetchCustomerList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(fetchCustomerList({ page: 1, pagesize: 1000 }));
    }
  };
  const handleChangeCustomer = value => {
    setSearchCustomer(value);
  };

  const handleJobWorkChange = (value, rowIndex) => {
    const updatedWorkOrderDetails = [
      ...form.getFieldValue('work_order_details'),
    ];

    const currentRow = updatedWorkOrderDetails[rowIndex] || {};

    updatedWorkOrderDetails[rowIndex] = {
      ...currentRow,
      jobwork: value,
    };

    if (value.includes('Engineering')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        cutting: currentRow.cutting || false,
        machinings: currentRow.machinings || false,
        deburring: currentRow.deburring || false,
        cutting_price: currentRow.cutting_price || undefined,
        machinings_price: currentRow.machinings_price || undefined,
        deburring_price: currentRow.deburring_price || undefined,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        cutting: false,
        machinings: false,
        deburring: false,
        cutting_price: undefined,
        machinings_price: undefined,
        deburring_price: undefined,
      };
      setSelectedEngineeringOptions(prev => ({
        ...prev,
        [rowIndex]: [],
      }));
    }

    if (value.includes('Laser marking')) {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description: currentRow.laser_marking_description || undefined,
        laser_marking_price: currentRow.laser_marking_price || undefined,
      };
    } else {
      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        laser_marking_description: undefined,
        laser_marking_price: undefined,
      };
    }

    if (value.includes('Surface treatment')) {
      const surfaceFinishArray = [];
      if (currentRow.anodising) surfaceFinishArray.push('anodising');
      if (currentRow.powder_coating) surfaceFinishArray.push('powder_coating');
      if (currentRow.pvdf) surfaceFinishArray.push('pvdf');

      setSelectedSurfaceFinish(prev => ({
        ...prev,
        [rowIndex]: surfaceFinishArray,
      }));

      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        anodising: currentRow.anodising || false,
        powder_coating: currentRow.powder_coating || false,
        pvdf: currentRow.pvdf || false,
        anodising_description: currentRow.anodising_description || undefined,
        anodising_price: currentRow.anodising_price || undefined,
        powder_coating_description: currentRow.powder_coating_description || undefined,
        powder_coating_price: currentRow.powder_coating_price || undefined,
        pvdf_description: currentRow.pvdf_description || undefined,
        pvdf_price: currentRow.pvdf_price || undefined,
      };
    } else {
      setSelectedSurfaceFinish(prev => ({
        ...prev,
        [rowIndex]: [],
      }));

      updatedWorkOrderDetails[rowIndex] = {
        ...updatedWorkOrderDetails[rowIndex],
        anodising: false,
        powder_coating: false,
        pvdf: false,
        anodising_description: undefined,
        anodising_price: undefined,
        powder_coating_description: undefined,
        powder_coating_price: undefined,
        pvdf_description: undefined,
        pvdf_price: undefined,
      };
    }

    form.setFieldsValue({
      work_order_details: updatedWorkOrderDetails,
    });

    setSelectedJobWork(prev => ({
      ...prev,
      [rowIndex]: value,
    }));
  };
  const handleCheckboxJobWorkChange = (field, checked, rowIndex) => {
    const updatedWorkOrderDetails = [
      ...form.getFieldValue('work_order_details'),
    ];

    if (['cutting', 'machinings', 'deburring'].includes(field)) {
      setSelectedEngineeringOptions(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return {
          ...prev,
          [rowIndex]: newSelected,
        };
      });
    }

    if (['anodising', 'powder_coating', 'pvdf'].includes(field)) {
      setSelectedSurfaceFinish(prev => {
        const prevSelected = prev[rowIndex] || [];
        let newSelected;
        if (checked) {
          newSelected = [...prevSelected, field];
        } else {
          newSelected = prevSelected.filter(f => f !== field);
        }
        return {
          ...prev,
          [rowIndex]: newSelected,
        };
      });
    }

    updatedWorkOrderDetails[rowIndex] = {
      ...updatedWorkOrderDetails[rowIndex],
      [field]: checked,
    };

    form.setFieldsValue({
      quotation_details: updatedWorkOrderDetails,
    });
  };

  const handleprofile = async (value, index) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('work_order_details'),
    ];
    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      die_profile: value?.value,
    };
    form.setFieldsValue({
      work_order_details: updatedQuotationDetails,
    });
    setSelectedIndex(index); // Track which row is being updated
    try {
      const response = await dispatch(
        fetchDieProfileById(value?.value),
      ).unwrap();

      if (response?.results?.data?.length > 0) {
        const customerRefNo =
          response.results.data[0]?.customer_reference_number || '';
        const currentWTKg = response.results.data[0]?.wt_kg_p_mt || '';
        setCurrentWTKg(currentWTKg);
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_number: customerRefNo,
          wt_kg_p_mt: currentWTKg,
        };
        form.setFieldsValue({
          work_order_details: updatedQuotationDetails,
        });
      } else {
        console.warn('No data found for the selected die profile.');
      }
    } catch (error) {
      console.error('Error fetching customer reference number:', error);
    }
  };

  useEffect(() => {
    if (selectedIndex === null) return; // Skip if no index is selected
    const workOrderDetails = form.getFieldValue('work_order_details') || [];
    const updatedDetails = [...workOrderDetails];
    const item = updatedDetails[selectedIndex];

    if (item) {
      const currentKg = currentWTKg || 0;
      const length = parseFloat(item.length) || 0;
      const pieces = parseFloat(item.pieces) || 0;
      const netWeight = ((currentKg * length) / 1000) * pieces;
      const toleranceValue = form.getFieldValue('tolerance') || '';
      const tolerancePercent = toleranceValue
        ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
        : 0;
      const isPositive = toleranceValue.includes('+');
      const isNegative = toleranceValue.includes('-');
      let max_weight = netWeight;
      let min_weight = netWeight;

      if (tolerancePercent > 0) {
        if (isPositive && isNegative) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight * (1 - tolerancePercent / 100);
        } else if (isPositive) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight; // Fix: Keep it same
        } else if (isNegative) {
          min_weight = netWeight * (1 - tolerancePercent / 100);
          max_weight = netWeight; // Fix: Keep it same
        }
      }
      updatedDetails[selectedIndex] = {
        ...item,
        net_weight: netWeight.toFixed(3),
        max_weight: max_weight.toFixed(3),
        min_weight: min_weight.toFixed(3),
      };
      form.setFieldsValue({
        work_order_details: updatedDetails,
      });
    }
  }, [currentWTKg, selectedIndex, form]); // Runs only when selectedIndex or currentWTKg changes

  const handleFieldChange = (index, changedField, value) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('work_order_details'),
    ];
    const row = { ...updatedQuotationDetails[index] } || {}; // Create a copy to avoid reference issues
    const currentKg = row?.wt_kg_p_mt || currentWTKg || 0;
    const length = parseFloat(row.length) || 0;
    const pieces = parseFloat(row.pieces) || 0;
    const net_weight = parseFloat(row.net_weight) || 0;
    let calculatedNetWeight = net_weight;
    let calculatedPieces = pieces;
    if (changedField === 'net_weight') {
      if (net_weight > 0 && length > 0 && currentKg > 0) {
        calculatedPieces = net_weight / (currentKg * (length / 1000));
      }
    }

    if (changedField === 'pieces') {
      if (pieces > 0 && length > 0 && currentKg > 0) {
        calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
        calculatedNetWeight = parseFloat(calculatedNetWeight.toFixed(3));
      }
    }

    if (changedField === 'length') {
      if (net_weight > 0 && length > 0 && currentKg > 0) {
        calculatedPieces = net_weight / (currentKg * (length / 1000));
        calculatedNetWeight =
          ((currentKg * length) / 1000) *
          parseFloat(calculatedPieces.toFixed(0));
        calculatedNetWeight = parseFloat(calculatedNetWeight.toFixed(3));
      }
    }
    const toleranceValue = form.getFieldValue('tolerance') || '';
    const tolerancePercent = toleranceValue
      ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
      : 0;
    const isPositive = toleranceValue.includes('+');
    const isNegative = toleranceValue.includes('-');
    let max_weight = calculatedNetWeight;
    let min_weight = calculatedNetWeight;

    if (tolerancePercent > 0) {
      if (isPositive && isNegative) {
        max_weight = calculatedNetWeight * (1 + tolerancePercent / 100);
        min_weight = calculatedNetWeight * (1 - tolerancePercent / 100);
      } else if (isPositive) {
        max_weight = calculatedNetWeight * (1 + tolerancePercent / 100);
        min_weight = calculatedNetWeight;
      } else if (isNegative) {
        min_weight = calculatedNetWeight * (1 - tolerancePercent / 100);
        max_weight = calculatedNetWeight;
      }
    }

    max_weight = parseFloat(max_weight.toFixed(3));
    min_weight = parseFloat(min_weight.toFixed(3));
    const updatedWorkOrderDetails = [...updatedQuotationDetails];
    const updatedRow = {
      ...row,
      net_weight: calculatedNetWeight,
      wt_kg_p_mt: currentKg,
      max_weight: max_weight,
      min_weight: min_weight,
    };
    if (changedField === 'net_weight' || changedField === 'length') {
      updatedRow.pieces = Math.round(calculatedPieces);
    }
    updatedWorkOrderDetails[index] = updatedRow;
    form.setFieldsValue({
      work_order_details: updatedWorkOrderDetails,
    });
  };

  const handleTemer = (selected, option, index) => {
    const updatedDetails = form
      .getFieldValue('work_order_details')
      .map((item, i) => (i === index ? { ...item, temper: selected } : item));

    form.setFieldsValue({ work_order_details: updatedDetails });
  };
  const [btnLoading, setBtnLoading] = useState(false);
  const handleFinish = values => {
    setBtnLoading(true); // Set loading state to true
    const formattedOrderDate = dayjs(values.order_date).format('YYYY-MM-DD');
    const formattedDeliveryDate = dayjs(values.delivery_date).format(
      'YYYY-MM-DD',
    );
    const formattedPurchaseOrderDate = dayjs(values.purchase_order_date).format(
      'YYYY-MM-DD',
    );

    const payload = {
      quotation_no: quotationNumber,
      bill_to: values.bill_to,
      ship_to: values.ship_to,
      order_date: formattedOrderDate,
      delivery_date: formattedDeliveryDate,
      purchase_order_no: values.purchase_order_no,
      purchase_order_date: formattedPurchaseOrderDate,
      packing_type: values.packing_type,
      project_name: values.project_name,
      nalco_rate: values.nalco_rate,
      workorder_type: values.workorder_type,
      tolerance: values.tolerance,
      status: values.status,
      order_no: values.order_no,
      work_order_details: values.work_order_details.map(detail => {
        const formattedDetail = {
          die_profile: detail?.die_profile?.value
            ? detail?.die_profile?.value
            : detail?.die_profile,
          description: detail?.description ? detail?.description : '',
          alloy: detail.alloy
            ? typeof detail.alloy === 'object'
              ? detail.alloy.value
              : detail.alloy
            : null,
          temper: detail.temper
            ? typeof detail.temper === 'object'
              ? detail.temper.value
              : detail.temper
            : null,

          customer_reference_number: detail.customer_reference_number,
          length: parseFloat(detail.length) || null,
          pieces: parseFloat(detail.pieces) || null,
          net_weight: parseFloat(detail.net_weight) || null,
          min_weight: parseFloat(detail.min_weight) || null,
          max_weight: parseFloat(detail.max_weight) || null,
          nalco_rate: parseFloat(detail.nalco_rate) || null,
          nalco_rate_change_reason: detail.nalco_rate_change_reason,
          modify_nalco_rate: detail?.modify_nalco_rate
            ? detail.modify_nalco_rate
            : false,
          conversion: parseFloat(detail.conversion) || null,
          finishing_price: parseFloat(detail.finishing_price) || null,
          jobwork: detail?.jobwork,
          cutting: detail?.cutting,
          machinings: detail?.machinings || false,
          deburring: detail?.deburring || false,
          cutting_price: detail?.cutting_price,
          machinings_price: detail?.machinings_price,
          deburring_price: detail?.deburring_price,
          anodising: detail?.anodising || false,
          powder_coating: detail?.powder_coating || false,
          pvdf: detail?.pvdf || false,
          anodising_description: detail?.anodising_description,
          anodising_price: detail?.anodising_price,
          powder_coating_description: detail?.powder_coating_description,
          powder_coating_price: detail?.powder_coating_price,
          pvdf_description: detail?.pvdf_description,
          pvdf_price: detail?.pvdf_price,
          laser_marking_description: detail?.laser_marking_description || undefined,
          laser_marking_price: detail?.laser_marking_price || undefined,
        };

        Object.keys(formattedDetail).forEach(key => {
          if (formattedDetail[key] === null) {
            delete formattedDetail[key];
          }
        });

        return formattedDetail;
      }),
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(payload));
    if (fileList.length > 0 && fileList[0]?.originFileObj) {
      formData.append('po_copy', fileList[0].originFileObj);
    }
    dispatch(quotationCreateWorkoder({ values: formData }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Quotation Converted Successfully!');
          setQuotationNumber(null);
          navigate(`/view-quotation-list/${id}`);
        }
      })
      .catch(error => {
        let displayMessage = '';
        if (typeof error === 'object') {
          displayMessage = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('\n');
          message.error(displayMessage);
        } else {
          message.error(
            `Error: ${error || 'Failed to convert to work order.'}`,
          );
        }
      })
      .finally(() => {
        setBtnLoading(false); // Reset loading state
      });
  };

  const handleSameCustomerCheck = e => {
    const checked = e.target.checked;
    setSameCustomer(checked);

    if (checked) {
      const selectedCustomer = form.getFieldValue('bill_to');
      form.setFieldsValue({
        ship_to: selectedCustomer,
      });
    } else {
      form.setFieldsValue({
        ship_to: null,
      });
    }
  };

  
  const handleToleranceChange = value => {
    const workOrderDetails = form.getFieldValue('work_order_details') || [];
    const toleranceMatch = value.match(/(\+-|\+|-)?\d+/g);
    const toleranceValue = toleranceMatch
      ? Math.abs(parseFloat(toleranceMatch[0].replace('+-', '')))
      : 0;
    const hasPositive =
      toleranceMatch.some(val => val.includes('+')) && !value.includes('+-');
    const hasNegative =
      toleranceMatch.some(val => val.includes('-')) && !value.includes('+-');
    const hasBoth = value.includes('+-') || value.includes('±');

    const updatedDetails = workOrderDetails.map(item => {
      const netWeight = parseFloat(item.net_weight) || 0;

      let max_weight = netWeight;
      let min_weight = netWeight;

      if (toleranceValue > 0) {
        if (hasBoth) {
          max_weight = netWeight * (1 + toleranceValue / 100);
          min_weight = netWeight * (1 - toleranceValue / 100);
        } else if (hasPositive) {
          max_weight = netWeight * (1 + toleranceValue / 100);
          min_weight = netWeight; // No change for minus
        } else if (hasNegative) {
          min_weight = netWeight * (1 - toleranceValue / 100);
          max_weight = netWeight; // No change for plus
        }
      }

      return {
        ...item,
        net_weight: netWeight.toFixed(3),
        max_weight: max_weight.toFixed(3),
        min_weight: min_weight.toFixed(3),
      };
    });
    form.setFieldsValue({ work_order_details: updatedDetails });
  };
  
  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Create Work Order</h2>
          <div className="bredcrumbwrp">
            <Link to={`/view-quotation-list/${id}`} className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                {
                  title: (
                    <Link to={`/view-quotation-list/${id}`}>
                      View Quotation
                    </Link>
                  ),
                },
                { title: 'Create Work Order' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="bill_to"
                  label="Customer (Bill To)"
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Select
                    placeholder="Please Select Company Name"
                    onChange={value => handleBillToChange(value)}
                    onSearch={handleSearchCustomer}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch={true}
                    value={searchCustomer}
                    allowClear
                  >
                    {[
                      ...new Map(
                        customerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option key={el.id} value={el.id}>
                        {el.customer_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <label
                  className="customlabel flex"
                  style={{ marginBottom: '3px' }}
                >
                  {' '}
                  Customer (Ship To) -
                  <div className="ml-2">
                    <Checkbox
                      checked={sameCustomer}
                      onChange={handleSameCustomerCheck}
                    >


                      Same as bill to
                    </Checkbox>
                  </div>
                </label>
                <Form.Item
                  name="ship_to"
                  label=""
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Select
                    placeholder="Please Select Company Name"
                    onChange={value => {
                      handleShipToChange(value);
                    }}
                    onSearch={handleSearchCustomer}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch={true}
                    value={searchCustomer}
                    allowClear
                  >
                    {[
                      ...new Map(
                        customerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option key={el.id} value={el.id}>
                        {el.customer_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[
                    { required: true, message: 'Please select order date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabled
                    defaultValue={moment()} // Current date as default
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="delivery_date"
                  label="Delivery Date"
                  rules={[
                    { required: true, message: 'Please select delivery date' },
                    () => ({
                      validator(_, value) {
                        const orderDate = form.getFieldValue('order_date');
                        if (
                          !value ||
                          !orderDate ||
                          value.isAfter(orderDate, 'day') ||
                          value.isSame(orderDate, 'day')
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'Delivery date must be on or after the order date',
                          ),
                        );
                      },
                    }),
                  ]}
                >
                  <DatePicker style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabledDate={disablePastDates}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Form.Item
                  name="purchase_order_no"
                  label="Purchase Order No"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid purchase order no',
                    },
                  ]}
                >
                  <Input placeholder="Enter Purchase Order No" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_date"
                  label="Purchase Order Date"
                  rules={[
                    {
                      required: true,
                      message: 'Please select purchase order date',
                    },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    style={{ width: '100%' }}
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="packing_type"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select mode of packing' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    options={Array.from(
                      new Map(
                        packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                      ).values()
                    )}
                    mode="multiple"
                    loading={packingModeLoading}
                  />
                </Form.Item>

              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="project_name"
                  label="Project Name"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid project name',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Project Name"
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ project_name: formattedValue }); // Update Form state
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="tolerance"
                  label="Tolerance"
                  rules={[
                    {
                      required: true,
                      message: 'Please select a tolerance value',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Tolerance"
                    onChange={handleToleranceChange}
                  >
                    <Option value="Zero(0)">Zero(0)</Option>
                    <Option value="+-3%" style={{ letterSpacing: '2px' }}>
                      ±3%
                    </Option>
                    <Option value="+-5%">±5%</Option>
                    <Option value="+-7%">±7%</Option>
                    <Option value="+-10%">±10%</Option>
                    <Option value="+3%">+3%</Option>
                    <Option value="+5%">+5%</Option>
                    <Option value="+7%">+7%</Option>
                    <Option value="+10%">+10%</Option>
                    <Option value="-3%">-3%</Option>
                    <Option value="-5%">-5%</Option>
                    <Option value="-7%">-7%</Option>
                    <Option value="-10%">-10%</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={6} sm={6} md={6} lg={4}>
                <Form.Item
                  name="nalco_rate"
                  label="Nalco Rate"
                  rules={[
                    { required: true, message: 'Please select rate per kg' },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="Fixed">Fixed</Radio>
                    <Radio value="Variable">Variable</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="workorder_type"
                  label="Work Order Type"
                  rules={[
                    { required: true, message: 'Please select work order type' },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="In House">In House</Radio>
                    <Radio value="Job Work">Job Work</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} lg={12} xxl={12}>
                <Form.Item name="remarks" label="Remarks">
                  <Input.TextArea
                    placeholder="Enter remarks"
                    onChange={e => {
                      const value = e.target.value;

                      const formattedValue =
                        value.trim() === ''
                          ? null
                          : value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());

                      form.setFieldsValue({ remarks: formattedValue }); // Update Form state
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="po_copy"
                  label="Purchase Order Copy"
                  required
                  valuePropName="fileList"
                  rules={[
                    {
                      validator: validateFileList,
                    },
                  ]}
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".pdf,.jpeg,.jpg,.png"
                      maxCount={1}
                      onChange={handleFileChange}
                      fileList={fileList}
                      showUploadList={{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                      }}
                    >
                      {fileList.length < 1 && (
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            backgroundColor: ' #FFFBF6',
                            color: 'black',
                            cursor: 'pointer',
                            fontWeight: '500',
                            fontSize: '14px',
                            gap: '8px',
                          }}
                        >
                          <PlusOutlined />
                          <span>Upload</span>
                        </div>
                      )}
                    </Upload>
                  </div>
                  {uploadDiaDiagramError && (
                    <div style={{ color: 'red', marginTop: 5 }}>
                      {uploadDiaDiagramError}
                    </div>
                  )}
                  <label className="filenote">
                    Upload PDF, JPEG, JPG or PNG file
                  </label>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="work_order_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      gutter={[24, 24]}
                      className="rowItem mx-0"
                      align="middle"
                      key={key}
                      wrap={false}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16} key={key}>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'die_profile']}
                              label="Profile Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select profile number',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Profile Number"
                                onChange={value => handleprofile(value, index)} // Pass the index here
                                labelInValue
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                showSearch={true}
                                allowClear
                                onSearch={handleSearchDieProfile}
                                value={searchDieProfile}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    dieProfileList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    data-weight={el.wt_kg_p_mt}
                                  >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              name={[name, 'customer_reference_number']}
                              label="Customer Reference No."
                            >
                              <Input placeholder="Enter Customer Ref. No" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={searchAlloy}
                                onChange={(value, option) =>
                                  handleAlloy(value, option)
                                }
                                onSearch={handleSearchAlloy}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;

                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();

                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    alloyList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option key={el.id} value={el.id}>
                                    {el?.alloy_code} - {el?.standard_name}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Temper"
                                loading={temperLoading}
                                value={searchTemper}
                                onPopupScroll={onScrollTemper}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                onChange={(value, option) =>
                                  handleTemer(value, option)
                                }
                                onSearch={handleSearchTemer}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    temperList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option key={el.id} value={el.id}>
                                    {el.name} - {el.code}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length(mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={() => {
                                  setTimeout(
                                    () => handleFieldChange(index, 'length'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              name={[name, 'pieces']}
                              label="Pieces"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter pieces',
                                },
                                 {
                                  pattern: /^[1-9]\d{0,5}$/,
                                  message: 'Pieces must be between 1 and 999999',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={() => {
                                  setTimeout(
                                    () => handleFieldChange(index, 'pieces'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'min_weight']}
                              label={`Net Weight - ${form.getFieldValue('tolerance')?.includes('-') ? form.getFieldValue('tolerance').match(/\d+/)?.[0] || '0' : '0'}%`}
                            >
                              <Input placeholder="0.0" disabled />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'net_weight']}
                              label="Net Weight (kg)"
                              rules={[
                                {
                                  pattern: /^\d{1,8}(\.\d{1,3})?$/,
                                  message:
                                    'Enter a valid number with up to 3 decimal places',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0.0"
                                onChange={e => {
                                  let value = e.target.value;
                                  if (
                                    /^\d{1,8}(\.\d{1,3})?$/.test(value) ||
                                    value === ''
                                  ) {
                                    handleFieldChange(
                                      index,
                                      'net_weight',
                                      value,
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'max_weight']}
                              label={`Net Weight + ${form.getFieldValue('tolerance')?.includes('+') ? form.getFieldValue('tolerance').match(/\d+/)?.[0] || '0' : '0'}%`}
                            >
                              <Input placeholder="0.0" disabled />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <label
                              className="customlabel flex"
                              style={{ marginBottom: '3px' }}
                            >
                              {' '}
                              Nalco -
                              <div className="ml-2">

                                <Checkbox
                                  disabled={
                                    form.getFieldValue([
                                      'work_order_details',
                                      name,
                                      'id',
                                    ]) && initialValues[name] === true // Use initial stored value
                                  }
                                  onChange={e => {
                                    const checked = e.target.checked;
                                    form.setFieldsValue({
                                      work_order_details: form
                                        .getFieldValue('work_order_details')
                                        .map((item, index) =>
                                          index === name
                                            ? {
                                              ...item,
                                              modify_nalco_rate: checked,
                                            }
                                            : item,
                                        ),
                                    });
                                  }}
                                >
                                  Edit Nalco Rate
                                </Checkbox>

                              </div>
                            </label>
                            <Form.Item
                              {...restField}
                              name={[name, 'nalco_rate']}
                              label=""
                              rules={[
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 10, // Set max before decimal
                                  maxAfterDecimal: 3, // Set max after decimal
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input
                                disabled={
                                  !form.getFieldValue([
                                    'work_order_details',
                                    name,
                                    'modify_nalco_rate',
                                  ])
                                }
                                onChange={e =>
                                  handleNalcoChange(e.target.value)
                                }
                                placeholder="0.0"
                              />
                            </Form.Item>

                          </Col>
                          {form.getFieldValue([
                            'work_order_details',
                            name,
                            'modify_nalco_rate',
                          ]) && (
                              <Col xs={12} md={8} xl={6} xxl={4}>
                                <Form.Item
                                  name={[name, 'nalco_rate_change_reason']}
                                  label="Remarks"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'Remark is required when Nalco Rate is updated',
                                    },
                                  ]}
                                >
                                  <Input placeholder="Enter Remarks" />
                                </Form.Item>
                              </Col>
                            )}
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 10, // Set max before decimal
                                  maxAfterDecimal: 3, // Set max after decimal
                                  allowDecimal: true,
                                  allowZero: true, // Allow 0 as a valid input
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'jobworks']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select surface finish',
                                },
                              ]}
                              label="Surface finish"
                            >
                              <AutoOpenSelect
                                placeholder="Select Surface finish"
                                mode="multiple"
                                onChange={value => {
                                  form.setFieldValue(['work_order_details', name, 'jobworks'], value);
                                  handleJobWorkChange(value, name)
                                }}
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                value={form.getFieldValue(['work_order_details', name, 'jobworks'])}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {jobWorkdata?.map(item => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </AutoOpenSelect>

                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '30px',
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 15) {
                            add({ nalco_rate: pricePerKg });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={btnLoading}
            >
              Convert Quotation To Work Order
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default ConvertToWorkOrder;
